import './ContextMenuColumnList.49d993e176d7f77c5aa22f7f9b60427e.css';
export default {"column":"_column_1xy8x_1"};